import type { CleaningTeamResponse } from '@/shared/api';
import { Button } from '@/shared/components';
import { cn } from '@/shared/lib/cn';

/** Teams als Karten: Name, Stand, aktive Mitglieder, Objekte, Leitung; ein Weg zum Bearbeiten. */
export function CleaningTeamsList({
  teams,
  onEdit,
}: {
  teams: CleaningTeamResponse[];
  onEdit: (team: CleaningTeamResponse) => void;
}) {
  return (
    <ul className="grid gap-3 md:grid-cols-2">
      {teams.map((team) => {
        const activeMembers = team.members.filter((member) => member.status === 'Active');
        const leads = activeMembers.filter((member) => member.role === 'Leader');
        const active = team.status === 'Active';
        return (
          <li
            key={team.id}
            className="border-hairline rounded-tile flex flex-col gap-3 border bg-white p-4"
          >
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="min-w-0">
                <h2 className="wrap-break-word font-serif text-xl font-bold">{team.name}</h2>
                <p className="text-ink-soft mt-1 text-sm">
                  {activeMembers.length} aktive {activeMembers.length === 1 ? 'Person' : 'Personen'}{' '}
                  · {team.propertyGroupIds.length}{' '}
                  {team.propertyGroupIds.length === 1 ? 'Objekt' : 'Objekte'}
                </p>
                <p className="text-ink-soft mt-0.5 text-sm">
                  {leads.length > 0
                    ? `Leitung: ${leads.map((lead) => lead.name).join(', ')}`
                    : 'Noch keine Leitung'}
                </p>
              </div>
              <span
                className={cn(
                  'rounded-pill inline-flex h-6 items-center px-2.5 text-[11px] font-bold',
                  active ? 'bg-forest-soft text-forest-deep' : 'bg-card-alt text-ink-soft',
                )}
              >
                {active ? 'Aktiv' : 'Inaktiv'}
              </span>
            </div>
            <Button
              variant="secondary"
              className="min-h-11 self-start"
              aria-label={`${team.name} bearbeiten`}
              onClick={() => onEdit(team)}
            >
              Bearbeiten
            </Button>
          </li>
        );
      })}
    </ul>
  );
}
